<template>
  <div class="index-wrap">
    <back-button />
    <IndexHeader :user="user" />
    <div class="index-label">
      <img :src="require('@/assets/img/label-icon.png')" />
      <img class="time-icon" :src="require('@/assets/img/time-icon.png')" />
      <img class="sub-icon" :src="require('@/assets/img/sub-title-icon.png')" />
    </div>
    <div class="menu-wrap">
      <van-row type="flex" justify="space-between">
        <van-col>
          <div
            class="menu-item print-1"
            @click="$router.push('/credential/list')"
          ></div>
        </van-col>
        <van-col>
          <div
            class="menu-item print-4"
            @click="$router.push('/errors?type=1')"
          ></div>
        </van-col>
        <van-col>
          <div class="menu-item print-2" @click="$router.push('/result')"></div>
        </van-col>
      </van-row>
      <van-row type="flex" justify="space-between">
        <van-col>
          <div class="menu-item print-3" @click="$router.push('/rank')"></div>
        </van-col>
        <van-col>
          <div class="menu-item print-5" @click="$router.push('/reward')"></div>
        </van-col>
        <van-col>
          <div class="menu-item print-6" @click="$router.push('/week')"></div>
        </van-col>
      </van-row>
    </div>
    <!-- <div class="bottom-label">
        <img :src="require('@/assets/img/bottom-label.png')"/>
      </div> -->
  </div>
</template>
<script>
import BackButton from "@/components/BackButton.vue";
import IndexHeader from "@/components/IndexHeader.vue";
export default {
  components: {
    BackButton,
    IndexHeader,
  },
  computed: {
    user() {
      return this.$store.state.user?.user;
    },
  },
};
</script>
<style lang="scss" scoped>
.index-wrap {
  position: relative;
  @include index-bg;
  .index-label {
    min-height: 400px;
    margin-top: 82px;
    text-align: center;
    img {
      width: 100%;
      vertical-align: top;
    }
    .time-icon {
      width: 216px;
    }
    .sub-icon {
      width: 262px;
    }
  }

  .menu-wrap {
    z-index: 100;
    padding: 30px 17px 0;

    .menu-item {
      width: 104px;
      height: 53px;
      margin-bottom: 19px;
      cursor: pointer;
    }

    @for $i from 1 through 6 {
      .print-#{$i} {
        background: url("~@/assets/img/print-#{$i}.png")
          no-repeat
          top
          center/100%;
      }
    }
  }
  // .bottom-label{
  //   position: absolute;
  //   bottom: 0;
  //   left: 0;
  //   z-index: 1;
  //   img{
  //     width: 100%;
  //     vertical-align: top;
  //   }
  // }
}
</style>
